"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function ensureLength(args, message) {
  let minLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  if (args.length < minLength) {
    throw new Error(message);
  }
}
exports.ensureLength = ensureLength;